import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, isAnalyticsEnabled, initGA } from '@utils/analytics';

// Component that tracks page views based on router location
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics on mount
    if (isAnalyticsEnabled) {
      initGA();
    }
  }, []);

  useEffect(() => {
    // Track page view on route change
    if (isAnalyticsEnabled) {
      trackPageView(location.pathname + location.search, document.title);
    }
  }, [location]);

  return null; // This component doesn't render anything
}
